app.service("DataApiService", ['$rootScope', '$http', '$sce', '$state', function ($rootScope, $http, $sce, $state) {

    const service = this;
    const modelConstructor = $rootScope.model_constructor;

    const DataApiModel = modelConstructor.extend(modelConstructor.BasicModel, {
        name: "Data Api",
        id: "data_api",
        overview_name: null,
        post_type: null,
        taxonomy_slug: null,
        root_category_slug: null,
        home_sref: null,
        category_sref: null,
        post_sref: null,

        categories_requested: false,
        overview_post_list_requested: false,
        post_slugs_requested: {},

        have_categories: false,
        have_overview_post_list: false,
        post_slugs_failed: {},

        categories: {},
        categories_by_id: {},
        category_list: [],
        root_categories: {},
        root_category_list: [],
        posts: {},
        overview_post_list: [],
        default_category: null,

        categoriesRequestCallbacks: [],
        overviewPostRequestCallbacks: [],
        postRequestCallbacks: {},
        
        requireCategories: requireCategories,
        requireOverviewPostList: requireOverviewPostList,
        requireCategoryPostList: requireCategoryPostList,
        requirePost: requirePost,
        broadcastUpdate: broadcastUpdate,

    });

    this.factory = new modelConstructor.ModelFactory({

        birth: function (values) {
            return new DataApiModel(values);
        },

        validVariationPointers: function (variationIDs) {
            return ['data_api_id'];
        },

        applyModelVariation: applyModelVariation
    });


    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        const dataApiID = variationIDs.data_api_id;

        switch (dataApiID) {
            case "announcement":
                model.overview_name = "Communication Updates";
                model.post_type = "announcement";
                model.taxonomy_slug = "announcement_categories";
                model.home_sref = "myba.announcement";
                model.category_sref = "myba.announcement.category";
                model.post_sref = "myba.announcement.category.post";
                break;
            case "article":
                model.overview_name = "Articles";
                model.post_type = "article";
                model.taxonomy_slug = "article_categories";
                model.home_sref = "myba.article";
                model.category_sref = "myba.article.category";
                model.post_sref = "myba.article.category.post";
                break;
            case "document":
                model.overview_name = "Documents";
                model.post_type = "media";
                model.taxonomy_slug = "media_category";
                model.root_category_slug = "public";
                model.home_sref = "myba.document";
                model.category_sref = "myba.document.category";
                break;
            case "marketing_asset":
                model.overview_name = "Marketing Assets";
                model.post_type = "media";
                model.taxonomy_slug = "marketing_assets";
                model.home_sref = "myba.marketing-asset";
                model.category_sref = "myba.marketing-asset.category";
                break;
            case "person":
                model.overview_name = "People";
                model.post_type = "person";
                model.taxonomy_slug = "person_categories";
                model.home_sref = "myba.person";
                model.category_sref = "myba.person.category";
                break;
            case "video":
                model.overview_name = "Videos";
                model.post_type = "video";
                model.taxonomy_slug = "video_categories";
                model.home_sref = "myba.video";
                model.category_sref = "myba.videos.category";
                model.post_sref = "myba.video.category.post";
                break;
            default:
                break;
        }
    }

    function requireOverviewPostList(callback) {
        const model = this.root;
        if (model.have_overview_post_list) {
            if (callback) {
                callback(model.overview_post_list)
            }
            return
        }
        if (callback) {
            model.overviewPostRequestCallbacks.push(callback);
        }
        if (model.overview_post_list_requested) {
            return;
        }
        model.overview_post_list_requested = true;
        model.requireCategories(function () {
            requestBatchItems(model.post_type, model.taxonomy_slug, "overview", model.root_category_slug, function (postList) {

                handlePostList(model, postList)
                model.have_overview_post_list = true;
                model.overview_post_list = postList;

                for (let categorySlug in model.categories) {
                    model.categories[categorySlug].overview_post_list = [];
                }

                for (let i = 0; i < postList.length; i++) {
                    const post = postList[i];
                    for (let postCategorySlug in post.categories) {
                        const category = model.categories[postCategorySlug];
                        if (category) {
                            category.overview_post_list.push(post);
                        }
                    }
                }

                for (let i = 0; i < model.overviewPostRequestCallbacks.length; i++) {
                    model.overviewPostRequestCallbacks[i](model.overview_post_list);
                }
                model.overviewPostRequestCallbacks.length = 0;
                model.broadcastUpdate();

            });
        });
    }

    function requirePost(postSlug, callback) {

        function handleCallbacks() {
            if (model.postRequestCallbacks[postSlug]) {
                for (let i = 0; i < model.postRequestCallbacks[postSlug].length; i++) {
                    model.postRequestCallbacks[postSlug][i](model.posts[postSlug] ? model.posts[postSlug] : null);
                }
                delete model.postRequestCallbacks[postSlug];
            }
            model.broadcastUpdate();
        }

        const model = this.root;
        if (model.posts[postSlug] || model.post_slugs_failed[postSlug]) {
            if (callback) {
                callback(model.posts[postSlug] ? model.posts[postSlug] : null)
            }
            return
        }
        if (callback) {
            if (!model.postRequestCallbacks[postSlug]) {
                model.postRequestCallbacks[postSlug] = [];
            }
            model.postRequestCallbacks[postSlug].push(callback);
        }
        if (model.post_slugs_requested[postSlug]) {
            return;
        }
        model.post_slugs_requested[postSlug] = true;
        model.requireCategories(function () {
            requestPost(model.post_type, postSlug, function (post) {
                handlePostList(model, [post])
                handleCallbacks();
            }, function () {
                model.post_slugs_failed[postSlug] = true
                handleCallbacks();
            });
        });
    }

    function requireCategoryPostList(categorySlug, callback) {

        const model = this.root;

        function getFamilyCategories(category) {
            const categories = {};
            categories[category.slug] = category;
            for (let childCategorySlug in category.child_categories) {
                const childFamily = getFamilyCategories(category.child_categories[childCategorySlug]);
                for (let descendantSlug in childFamily) {
                    categories[descendantSlug] = childFamily[descendantSlug];
                }
            }

            return categories;
        }

        model.requireCategories(function () {

            const category = model.categories[categorySlug];

            if (!category) {
                if (callback) {
                    callback([])
                }
                return
            }

            if (category.have_post_list) {
                if (callback) {
                    callback(category.post_list)
                }
                return
            }
            if (callback) {
                category.postListRequestCallbacks.push(callback);
            }
            if (category.post_list_requested) {
                return;
            }
            category.post_list_requested = true;
            requestBatchItems(model.post_type, model.taxonomy_slug, "category_post", category.slug, function (postList) {

                let i, familyCategorySlug, familyCategory;
                handlePostList(model, postList);

                const familyCategories = getFamilyCategories(category);
                for (familyCategorySlug in familyCategories) {
                    familyCategory = familyCategories[familyCategorySlug];
                    familyCategory.posts = {};
                    familyCategory.post_list = [];
                    familyCategory.post_sorted_list = [];
                }

                for (i = 0; i < postList.length; i++) {
                    const post = postList[i];
                    for (let postCategorySlug in post.categories) {
                        familyCategory = familyCategories[postCategorySlug];
                        if (familyCategory) {
                            familyCategory.posts[post.slug] = post;
                            familyCategory.post_list.push(post);
                            familyCategory.post_sorted_list.push(post);
                        }
                    }
                }

                for (familyCategorySlug in familyCategories) {
                    familyCategory = familyCategories[familyCategorySlug];
                    familyCategory.post_sorted_list.sort(function (a, b) {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }
                        return 0;
                    });
                    familyCategory.have_post_list = true;
                }

                for (i = 0; i < category.postListRequestCallbacks.length; i++) {
                    category.postListRequestCallbacks[i](category.post_list);
                }
                category.postListRequestCallbacks.length = 0;
                model.broadcastUpdate();

            });

        });
    }

    function requireCategories(callback) {

        function applyCategorySorting(categories) {

            categories.sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });

            for (let i = 0; i < categories.length; i++) {
                const category = categories[i];
                applyCategorySorting(category.child_category_sorted_list)
            }
        }

        const model = this.root;
        if (!model.variation_ids.data_api_id) {
            return
        }
        if (model.have_categories) {
            if (callback) {
                callback(model.category_list)
            }
            return
        }
        if (callback) {
            model.categoriesRequestCallbacks.push(callback);
        }
        if (model.categories_requested) {
            return
        }
        model.categories_requested = true;


        requestBatchItems(model.post_type, model.taxonomy_slug, "taxonomy", model.root_category_slug, function (categoryList) {
            let i, category;

            const categories = {};

            const rootCategories = {}
            const rootCategoryList = [];
            const rootCategorySortedList = [];

            const categoriesByID = {};

            const defaultCategory = {
                name: model.overview_name,
                id: Number.MAX_SAFE_INTEGER,
                slug: model.post_type,
                is_default: true,
            }

            categoryList.push(defaultCategory);

            for (i = 0; i < categoryList.length; i++) {
                category = categoryList[i];
                category.href = model.category_sref ? $state.href(model.category_sref, {category_slug: category.slug}) : null;

                category.basic = JSON.parse(JSON.stringify(category))

                category.child_categories = {};
                category.child_category_list = [];
                category.child_category_sorted_list = [];

                category.posts = {};
                category.post_list = [];
                category.post_sorted_list = [];
                category.overview_post_list = [];

                category.post_list_requested = false;
                category.have_post_list = false;

                category.postListRequestCallbacks = [];

                categories[category.slug] = category;
                categoriesByID[category.id] = category;
            }

            delete categories[defaultCategory.slug]
            delete categoriesByID[defaultCategory.id]
            categoryList.pop();

            model.default_category = defaultCategory;

            for (i = 0; i < categoryList.length; i++) {
                category = categoryList[i];
                const parentCategory = category.parent && categoriesByID[category.parent] ? categoriesByID[category.parent] : null;
                category.parentSlug = parentCategory ? parentCategory.slug : null;
                category.basic.parentSlug = category.parentSlug;

                if (category.parentSlug) {
                    parentCategory.child_categories[category.slug] = category;
                    parentCategory.child_category_list.push(category)
                    parentCategory.child_category_sorted_list.push(category)
                } else {
                    rootCategories[category.slug] = category;
                    rootCategoryList.push(category);
                    rootCategorySortedList.push(category);
                }
            }

            applyCategorySorting(rootCategorySortedList)
            model.categories = categories;
            model.categories_by_id = categoriesByID;
            model.category_list = categoryList;
            model.root_categories = rootCategories;
            model.root_category_list = rootCategoryList;
            model.root_category_sorted_list = rootCategorySortedList;

            model.have_categories = true;

            for (i = 0; i < model.categoriesRequestCallbacks.length; i++) {
                model.categoriesRequestCallbacks[i](model.category_list);
            }
            model.categoriesRequestCallbacks.length = 0;
            model.broadcastUpdate();

        });
    }

    function requireDefaultCategory(model) {
        const defaultCategory = model.default_category;
        if (!defaultCategory) {
            return false;
        }
        if (!model.categories_by_id[defaultCategory.id]) {
            model.categories[defaultCategory.slug] = defaultCategory;
            model.categories_by_id[defaultCategory.id] = defaultCategory;
            model.category_list.push(defaultCategory)
        }
        return true;
    }

    function requestBatchItems(postType, taxonomySlug, dateTypeID, categorySlug, callback, errorCallback) {

        let url = "/request/cache-request.php?request_type=get_content&cache_id=data&content_type=batch&post_type=" + postType + "&taxonomy_slug=" + taxonomySlug + "&date_type_id=" + dateTypeID;

        if (categorySlug) {
            url += "&category_slug=" + categorySlug;
        }

        $http({
            url: url,
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                const data = response.data ? response.data : [];
                if (callback) {
                    callback(data);
                }

            }, function () {
                if (errorCallback) {
                    errorCallback();
                }
            });
    }

    function requestPost(postType, postSlug, callback, errorCallback) {

        const url = "/request/cache-request.php?request_type=get_content&cache_id=data&content_type=post&post_type=" + postType + "&post_slug=" + postSlug;

        $http({
            url: url,
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                const data = response.data ? response.data : null;
                if (callback) {
                    callback(data);
                }

            }, function () {
                if (errorCallback) {
                    errorCallback();
                }
            });
    }

    function handlePostList(model, postList) {
        let i, j, category;

        function getChildDepth(category, inCategories) {
            let childDepth = 0;
            let hasChildren = false;
            for (let childCategorySlug in category.child_categories) {
                if (inCategories[childCategorySlug]) {
                    hasChildren = true;
                    const thisDepth = getChildDepth(category.child_categories[childCategorySlug], inCategories);
                    if (thisDepth > childDepth) {
                        childDepth = thisDepth;
                    }
                }
            }
            if (childDepth === 0) {
                return hasChildren ? 1 : 0;
            }
            return childDepth + 1;
        }

        for (i = 0; i < postList.length; i++) {
            const post = postList[i];
            if (post.restricted_to === "blossom-avenue") {
                if (!$rootScope.model.account.is_blossom_customer) {
                    postList.splice(i, 1);
                    i--;
                    continue;
                }
            }
            post.basic = JSON.parse(JSON.stringify(post))
            post.date_object = new Date(Date.parse(post.date_gmt));
            post.html_content_blocks = handleDataHTML(post.html_encoded_blocks_output);
            if (post.title && post.title.rendered) {
                post.title.rendered = $rootScope.site_helper.decodeHTML(post.title.rendered);
            }
            if (post.description && post.description.rendered) {
                post.html_description = handleDataHTML(post.description.rendered);
            }
            post.readable_date = post.date_object.toLocaleString('default', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            const categories = {};
            const categoryList = [];
            let primaryCategorySlug = null;
            if (post[model.taxonomy_slug]) {
                const taxonomyIdList = post[model.taxonomy_slug];
                let fromCategories = [];
                for (j = 0; j < taxonomyIdList.length; j++) {
                    const categoryID = taxonomyIdList[j];
                    category = model.categories_by_id[categoryID];
                    if (category) {
                        fromCategories.push(category);
                    }
                }
                if (fromCategories.length === 0) {
                    if (requireDefaultCategory(model)) {
                        fromCategories = [model.default_category];
                    }
                }

                for (j = 0; j < fromCategories.length; j++) {
                    category = fromCategories[j];
                    if (!primaryCategorySlug) {
                        primaryCategorySlug = category.slug;
                    }
                    const familyToAdd = [];
                    let nextToAdd = category;
                    while (nextToAdd) {
                        if (categories[nextToAdd.slug]) {
                            break;
                        }
                        familyToAdd.unshift(nextToAdd);
                        nextToAdd = nextToAdd.parent ? model.categories_by_id[nextToAdd.parent] : null;
                    }

                    for (let k = 0; k < familyToAdd.length; k++) {
                        const relatedCategory = familyToAdd[k];
                        const categoryClone = JSON.parse(JSON.stringify(relatedCategory.basic));
                        categories[relatedCategory.slug] = categoryClone;
                        categoryList.push(categoryClone)

                        relatedCategory.posts[post.slug] = post;
                    }
                }
            }
            post.categories = categories;
            post.category_list = categoryList;

            for (j = 0; j < categoryList.length; j++) {
                category = categoryList[j];
                category.childDepth = getChildDepth(model.categories[category.slug], post.categories)

            }


            post.href = model.post_sref ? $state.href(model.post_sref, {
                category_slug: primaryCategorySlug,
                post_slug: post.slug
            }) : null;
            if (post.acf && post.acf.video_id) {
                post.acf.video_src = $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + post.acf.video_id+'?enablejsapi=1');
            }

            model.posts[post.slug] = post;
        }
    }

    function handleDataHTML(htmlEncodedBlocksOutput) {
        let output = "";
        if (htmlEncodedBlocksOutput) {
            if (!Array.isArray(htmlEncodedBlocksOutput)) {
                htmlEncodedBlocksOutput = [htmlEncodedBlocksOutput]
            }
            for (let i = 0; i < htmlEncodedBlocksOutput.length; i++) {
                let block = htmlEncodedBlocksOutput[i];
                if (block.substring(0, 1) === "\"") {
                    block = block.substring(1)
                }
                if (block.substring(block.length - 1) === "\"") {
                    block = block.substring(0, block.length - 1);
                }
                output += block;
            }
        }
        output = $sce.trustAsHtml(output)
        return output;
    }

    function broadcastUpdate() {
        const model = this.root;
        $rootScope.$broadcast("data_api_update", {data_api_id: model.variation_ids.data_api_id});
    }

    service.productVideosByTags = function (tags, callback) {
        const dataApiModel = $rootScope.service.data_api.factory.getModel({data_api_id: "video"});
        dataApiModel.requireOverviewPostList(function (postList) {
            let i, j;
            const validPosts = [];
            for (i = 0; i < postList.length; i++) {
                const post = postList[i];
                const productTags = [];
                if (post.video_meta && post.video_meta.product_tags) {
                    for (j = 0; j < post.video_meta.product_tags.length; j++) {
                        const tag = post.video_meta.product_tags[j].split("-").join("_");
                        let tags;
                        switch (tag) {
                            case "rigid_kitchen":
                                tags = ["kitchen_rigid_flat_pack", "rigid"];
                                break;
                            case "flat_pack_kitchen":
                                tags = ["kitchen_rigid_flat_pack", "flat_pack"];
                                break;
                            case "true_handleless_rigid_kitchen":
                                tags = ["kitchen_inrail", "rigid"];
                                break;
                            case "flat_pack_bedroom":
                                tags = ["bedroom_flat_pack", "flat_pack"];
                                break;
                            default:
                                tags = [tag];
                        }
                        for (let k = 0; k < tags.length; k++) {
                            productTags.push(tags[k])
                        }
                    }
                }
                let haveAll = true;
                for (j = 0; j < tags.length; j++) {
                    if (!tags[j]) {
                        continue;
                    }
                    if (!productTags.includes(tags[j])) {
                        haveAll = false;
                        break;
                    }
                }
                if (haveAll) {
                    validPosts.push(post);
                }
            }
            if (callback) {
                callback(validPosts);
            }
        });
    }


}]);